import { Backdrop, CircularProgress } from "@mui/material";
import { ArrowLeft, Check, Edit } from "feather-icons-react/build/IconComponents";
import { t } from "i18next";
import { useContext, useEffect, useMemo, useRef, useState } from "react";
import { QuestionCircleFill } from "react-bootstrap-icons";
import { Link, useLocation } from "react-router-dom";
import { useQueryClient } from "@tanstack/react-query";
import API from "../../API/newIndex";
import { addBlogCategory, fetchParentBlogCategories } from "../../services/blogCategoryService";
import { ChangePathContext } from "../../App";
import Breadcrumbs from "../../controllers/breadCrumbs";
import { GenerateSlugName } from "../../controllers/GenerateSlugName";
import { clientData } from "../../controllers/GetClient";
import ImageUploader from "../../controllers/ImageUploader";
import { useLastRoute } from "../../controllers/LastRouteContext";
import { parentNavigate } from "../../controllers/ParentNavigate";
import SourceCode from "../../controllers/SourceCode";
import { useRoutingByType } from "../../controllers/useRouting";
import { uploadTextEditorImage } from "../../utilities/staticFunction";
import AiTextGenerate from "../AiTextGenerate";
import {
  ButtonComponent,
  DetailsComponent,
  InputComponent,
  SelectComponent,
  RichTextEditor
} from "@shopeasy-dashboard-ui/ui-library";
import Notification from "../Notification";
const AddBlogCategory = () => {
  const queryClient = useQueryClient();
  const location = useLocation();
  const lastRoute = useLastRoute();

  const prevPage = useMemo(() => {
    if (location.state?.prevPage) return Number(location.state.prevPage);
    if (location.state?.state?.prevPage) return Number(location.state.state.prevPage);
    if (lastRoute) {
      try {
        const queryParams = new URLSearchParams(lastRoute.split("?")[1] || "");
        const p = queryParams.get("page");
        if (p) return Number(p);
      } catch (e) { }
    }
    return 1;
  }, [location.state, lastRoute]);

  const rawPrevUrl = location.state?.prevUrl || location.state?.state?.prevUrl || lastRoute;

  const defaultBackUrl = useMemo(() => {
    if (rawPrevUrl && (rawPrevUrl.includes("page=") || rawPrevUrl.includes("search="))) {
      return rawPrevUrl;
    }
    if (prevPage > 1) {
      return `/blog/categories?page=${prevPage}`;
    }
    return rawPrevUrl || lastRoute || "/blog/categories";
  }, [rawPrevUrl, lastRoute, prevPage]);
  const { saveChanges, setSaveChanges } = useContext(ChangePathContext);
  const [SelectedBlogParentCategory, setSelectedBlogParentCategory] = useState();
  const [isNotification, setIsNotification] = useState(false);
  const [notificationMsg, setNotificationMsg] = useState("");
  const [severity, setSeverity] = useState();
  const [BlogCatData, setBlogCatData] = useState({
    blogcategory_name: "",
    meta_tag_title: "",
    meta_tag_description: "",
    keyword: "",
    meta_image: "",
  });
  const [isMetaTitleCustom, setIsMetaTitleCustom] = useState(false);
  const [description, setDescription] = useState("");
  const { blogcategory_name, meta_tag_title, meta_tag_description, keyword, meta_image } = BlogCatData;
  const HandleInput = (e) => {
    if (e.target.name === "meta_tag_title") {
      setIsMetaTitleCustom(Boolean(e.target.value));
    }
    setBlogCatData((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };

  // get Parents Category
  const [ParentCategory, setParentCategory] = useState([]);
  const [isCategoryLoading, setIsCategoryLoading] = useState(false);
  const [hasSearched, setHasSearched] = useState(false);
  const GetParentCategory = async (searchKey = "") => {
    setIsCategoryLoading(true);
    try {
      const data = await fetchParentBlogCategories(searchKey);
      setParentCategory(data?.data?.records || []);
    } catch (error) {
      setIsNotification(true);
      setNotificationMsg(error?.message || error);
      setSeverity("error");
      setParentCategory([]);
    } finally {
      setIsCategoryLoading(false);
      setHasSearched(true);
    }
  };

  const parentCategoryOptions = useMemo(() => {
    const records = Array.isArray(ParentCategory) ? ParentCategory : (ParentCategory?.data?.records || []);
    return records;
  }, [ParentCategory]);

  const parentCategoryValue = useMemo(() => {
    return parentCategoryOptions?.find((cat) => cat._id === SelectedBlogParentCategory) || SelectedBlogParentCategory || null;
  }, [parentCategoryOptions, SelectedBlogParentCategory]);

  useEffect(() => { }, []);
  const [enableSlug, setEnableSlug] = useState(false);
  const slugInputRef = useRef(null);
  const [slugEdited, setSlugEdited] = useState(false);
  const [slugName, setSlugName] = useState("");
  const handleSlug = async (slug) => {
    if (slug?.length) {
      setSlugName(await GenerateSlugName(slug));
    } else {
      setSlugName("");
    }
  };
  const [btnLoading, setBtnLoading] = useState(false);
  const HandleSubmit = async (e) => {
    e.preventDefault();
    setBtnLoading(true);
    try {
      const payload = {
        ...BlogCatData,
        description: description,
        blog_category_slug_name: slugName,
        ...(SelectedBlogParentCategory ? { parent_blogcategory: SelectedBlogParentCategory } : ""),
      };
      const data = await addBlogCategory(payload);
      if (data.status === 200 || data.status === 304) {
        queryClient.invalidateQueries({ queryKey: ["blogCategories"] });
        setSaveChanges({
          isUnsaveChanges: false,
          showChangesPopup: false,
          backLink: defaultBackUrl,
          title: "add blog category",
        });
        parentNavigate(defaultBackUrl);
      }
    } catch (error) {
      setIsNotification(true);
      setNotificationMsg(error?.message || error);
      setSeverity("error");
    }
    setBtnLoading(false);
  };
  const [AiLoader, setAiloader] = useState(false);

  const generateMetaData = async (data, key) => {
    if (description?.length === 0) {
      setIsNotification(true);
      setNotificationMsg("Please enter description!");
      setSeverity("error");
    } else {
      try {
        setAiloader(true);
        const payload = {
          name: data,
        };
        if (key === "description") {
          let ApiCall = await API({
            url: "/admin/ai/category_meta_description",
            method: "post",
            data: payload,
          });
          const result = ApiCall?.data;
          setBlogCatData({
            ...BlogCatData,
            meta_tag_description: result?.data,
          });
        } else {
          let ApiCall = await API({
            url: "/admin/ai/category_meta_title",
            method: "post",
            data: payload,
          });
          const result = ApiCall?.data;
          setIsMetaTitleCustom(true);
          setBlogCatData((prev) => ({ ...prev, meta_tag_title: result?.data }));
        }
        setAiloader(false);
      } catch (error) {
        if (error?.response?.status === 429) {
          setIsNotification(true);
          setNotificationMsg(t("lang_Hit_chatgpt_limit"));
          setSeverity("warning");
        } else {
          setIsNotification(true);
          setNotificationMsg(error?.response?.data?.message);
          setSeverity("error");
        }
      } finally {
        setAiloader(false);
      }
    }
  };
  const handleClose = () => {
    setIsNotification(false);
    setNotificationMsg("");
    setSeverity("");
  };

  //Quil To HTML code and Functions
  const handleQuillChange = (value) => {
    setDescription(value);
  };
  const [html, setHtml] = useState({ htmlPP: false, code: "" });
  const saveHTML = (value) => {
    setHtml({ ...html, htmlPP: false });
    setDescription(value);
  };
  const closeCode = () => {
    setHtml({ ...html, htmlPP: false });
  };
  const protocol = process.env.REACT_APP_ENVIRONMENT === 'DEV' ? 'http://' : 'https://';
  const clientInfo = clientData;
  useEffect(() => {
    if (
      keyword?.length > 0 ||
      meta_tag_description?.length > 0 ||
      meta_tag_title?.length > 0 ||
      meta_image?.length > 0 ||
      blogcategory_name?.length > 0 ||
      description?.length > 0 ||
      SelectedBlogParentCategory?.length > 0
    ) {
      setSaveChanges({
        backLink: defaultBackUrl,
        isUnsaveChanges: true,
        showChangesPopup: false,
        title: "add blog category",
      });
    } else {
      setSaveChanges({
        backLink: defaultBackUrl,
        isUnsaveChanges: false,
        showChangesPopup: false,
        title: "add blog category",
      });
    }
  }, [
    keyword,
    meta_tag_description,
    meta_tag_title,
    meta_image,
    blogcategory_name,
    description,
    SelectedBlogParentCategory,
    defaultBackUrl,
  ]);

  const checkChanges = () => {
    if (
      keyword?.length > 0 ||
      meta_tag_description?.length > 0 ||
      meta_tag_title?.length > 0 ||
      meta_image?.length > 0 ||
      blogcategory_name?.length > 0 ||
      description?.length > 0 ||
      SelectedBlogParentCategory?.length > 0
    ) {
      setSaveChanges({
        isUnsaveChanges: true,
        showChangesPopup: true,
        backLink: defaultBackUrl,
        title: "add blog category",
      });
    } else {
      parentNavigate(defaultBackUrl);
    }
  };
  const filterOptionsForCategory = (options, state) => {
    const normalizedInputValue = state.inputValue?.toLowerCase();
    if (!normalizedInputValue || normalizedInputValue.length < 3) {
      return [];
    }
    return options.filter((option) => {
      const combinedFields = `${option?.parent_category?.toLowerCase() || ''} ${option?.blogcategory_name?.toLowerCase() || ''}`;
      return combinedFields.includes(normalizedInputValue);
    });
  };
  const [autocompleteSearch, setAutocompleteSearch] = useState("");
  useEffect(() => {
    if (autocompleteSearch && autocompleteSearch.length >= 3) {
      const handler = setTimeout(() => {
        GetParentCategory(autocompleteSearch);
      }, 500);

      return () => {
        clearTimeout(handler);
      };
    } else {
      setIsCategoryLoading(false);
      setHasSearched(false);
      setParentCategory([]);
    }
  }, [autocompleteSearch]);
  const [err, setErr] = useState(false);

  const blogRoute = useRoutingByType(`blog`);

  return (
    <>
      {isNotification && notificationMsg && (
        <Notification message={notificationMsg} close={handleClose} severity={severity} />
      )}
      {AiLoader && (
        <Backdrop
          sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={AiLoader}
          className="flex flex-col"
        >
          <CircularProgress color="inherit" />
          <p>{t("lang_ai_generate_content_loader")}</p>
        </Backdrop>
      )}
      <div className="h-auto overflow-y-auto pb-[130px] pt-5">
        <div className="px-[20px]">
          <div className="w-full lg:w-[70%] xl:w-[60%] mx-auto">
            <div className="flex items-center space-x-2">
              <button
                onClick={(e) => {
                  e.preventDefault();
                  checkChanges();
                }}
                className="back-arrow -ml-3.5"
              >
                <ArrowLeft />
              </button>
              <div className="flex-1 min-w-0">
                <Breadcrumbs
                  crumbs={[
                    { name: t("lang_Blog_Categories"), path: defaultBackUrl },
                    {
                      name: t("lang_Add_Blog_Category"),
                      path: "/blog/categories/add",
                    },
                  ]}
                />
                <div className="flex flex-wrap items-center gap-2 sm:gap-3 mt-1">
                  <h4 className="text-xl md:text-2xl font-semibold text-primary">
                    {t("lang_Add_New_Blog_Category")}
                  </h4>
                  <a
                    target="_blank"
                    rel="noreferrer"
                    href="https://help.shopeasy.ai/articles/blog-category-management"
                    className="how-it-works !m-0"
                  >
                    <QuestionCircleFill className="me-1.5" />
                    {t("lang_how_to_use")}
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="p-[20px]">
          <form
            onKeyDown={(e) => e.key === "Enter" && e.preventDefault()}
            method="POST"
            className="w-full lg:w-[70%] xl:w-[60%] mx-auto flex flex-col gap-3"
          >
            <DetailsComponent
              open={true}
              hasHr={false}
              showChevron={false}
              className="!pt-5 sm:!pt-[25px]"
            >
              <div className="mb-4">
                <label htmlFor="blogcategory_name">
                  <p className="text-[13px]">
                    {t("lang_Blog_Category_Name")}
                    <span className="text-red-500 ms-1">*</span>
                  </p>
                </label>
                <InputComponent
                  type="text"
                  id="blogcategory_name"
                  name="blogcategory_name"
                  value={blogcategory_name}
                  onChange={(e) => {
                    const newName = e.target.value;
                    if (!enableSlug && (!slugEdited || !slugName)) handleSlug(newName);
                    const shouldSyncMeta = !isMetaTitleCustom;
                    setBlogCatData((prev) => ({
                      ...prev,
                      blogcategory_name: newName,
                      ...(shouldSyncMeta ? { meta_tag_title: newName } : {}),
                    }));
                  }}
                  placeholder="e.g. Tech"
                  onBlur={() => {
                    if (!enableSlug && (!slugEdited || !slugName) && blogcategory_name) handleSlug(blogcategory_name);
                    if (!isMetaTitleCustom && !meta_tag_title && blogcategory_name) {
                      setBlogCatData((prev) => ({ ...prev, meta_tag_title: blogcategory_name }));
                    }
                  }}
                />
                <div className="flex items-center justify-between mt-1 text-xs text-gray-500 w-full gap-1 min-h-[24px]">
                  <div className="flex items-center w-[90%] min-w-0">
                    <a
                      href={`${protocol}${clientInfo?.custom_domain || clientInfo?.customer_domain}${blogRoute}/${(slugName || '').toLowerCase()}`}
                      target="_blank"
                      rel="noreferrer"
                      className="font-medium shrink-0 mr-2 hover:underline cursor-pointer text-blue-600 flex items-center"
                    >
                      Preview
                    </a>
                    {/* INLINE EDIT */}
                    {!enableSlug ? (
                      <div className="flex items-center gap-2 min-w-0">
                        <span className="truncate text-gray-500 min-w-0">
                          {`${protocol}${clientInfo?.custom_domain || clientInfo?.customer_domain}${blogRoute}/${(slugName || '').toLowerCase()}`}
                        </span>

                        <button
                          type="button"
                          onClick={() => {
                            setEnableSlug(true);
                            setTimeout(() => slugInputRef.current?.focus(), 50);
                          }}
                          className="text-gray-600 hover:text-black shrink-0 flex items-center"
                        >
                          <Edit size={14} />
                        </button>
                      </div>
                    ) : (
                      <div className="flex items-center gap-1 min-w-0 flex-1">
                        <span className="text-gray-400 shrink truncate max-w-[120px] sm:max-w-[200px] md:max-w-[300px] lg:max-w-[400px]">
                          {`${protocol}${clientInfo?.custom_domain || clientInfo?.customer_domain}${blogRoute}/`}
                        </span>

                        <InputComponent
                          ref={slugInputRef}
                          name="blog_category_slug_name"
                          className="flex-1 min-w-[60px] !h-[22px] !py-0.5 !px-1 text-xs"
                          value={slugName || ''}
                          onChange={(e) => {
                            setSlugName(e.target.value);
                            setSlugEdited(Boolean(e.target.value));
                          }}
                          onBlur={async () => {
                            if (slugName) {
                              const generated = await GenerateSlugName(slugName);
                              setSlugName(generated);
                            }
                          }}
                          onKeyDown={async (e) => {
                            if (e.key === "Enter") {
                              e.preventDefault();
                              if (!slugName) {
                                setIsNotification(true);
                                setSeverity("warning");
                                setNotificationMsg("Slug can not be empty!");
                                return;
                              }
                              const generated = await GenerateSlugName(slugName);
                              setSlugName(generated);
                              setEnableSlug(false);
                              setSlugEdited(true);
                            }
                          }}
                          isSlug={true}
                        />

                        <button
                          type="button"
                          className="text-green-600 ml-1 shrink-0 flex items-center"
                          onClick={async () => {
                            if (!slugName) {
                              setIsNotification(true);
                              setSeverity("warning");
                              setNotificationMsg("Slug can not be empty!");
                              return;
                            }

                            const generated = await GenerateSlugName(slugName);
                            setSlugName(generated);
                            setEnableSlug(false);
                            setSlugEdited(true);
                          }}
                        >
                          <Check size={14} />
                        </button>
                      </div>
                    )}
                  </div>

                  <span className={`shrink-0 text-end w-[10%] flex items-center justify-end ${(blogcategory_name?.length || 0) > 60 ? 'text-red-500 font-semibold' : ''}`}>
                    {blogcategory_name?.length || 0}/60
                  </span>
                </div>
              </div>
              <div className="max-w-full mb-4">
                <label htmlFor="blog Category">{t("lang_Parent_Blog_Category")}</label>
                <SelectComponent
                  className="autocomplete"
                  options={parentCategoryOptions}
                  value={parentCategoryValue}
                  getOptionLabel={(option) => {
                    if (!option) return '';
                    if (typeof option === 'string') return option;
                    return option?.blogcategory_name || option?.categoryName || (typeof option?.parent_category === 'string' ? option.parent_category.split('>').pop().trim() : '') || '';
                  }}
                  getOptionValue={(option) => option?._id}
                  filterOptions={filterOptionsForCategory}
                  onInputChange={(newInputValue) => {
                    if (typeof newInputValue === 'string' && newInputValue?.length >= 3) {
                      setHasSearched(false);
                      setAutocompleteSearch(newInputValue);
                    } else {
                      setIsCategoryLoading(false);
                      setHasSearched(false);
                      setAutocompleteSearch("");
                      setParentCategory([]);
                    }
                  }}
                  noOptionsText={
                    isCategoryLoading
                      ? `${t('lang_loading')}...`
                      : !autocompleteSearch || autocompleteSearch.length < 3 || !hasSearched
                        ? t('lang_enter_three_characters')
                        : t('lang_no_option_found')
                  }
                  onChange={(e, v) => {
                    const catId = typeof v === 'object' && v !== null ? v._id : (e?.target?.value || v);
                    setSelectedBlogParentCategory(catId ? catId : null);
                  }}
                  placeholder={`${t('lang_select')} ${t('lang_parent_category')}`}
                  isClearable={true}
                  tabIndex={2}
                />
              </div>
              <div>
                <div className="flex justify-between items-center mb-1">
                  <label htmlFor="description">{t("lang_Blog_Category_Description")}</label>
                </div>
                <RichTextEditor
                  htmlData={description}
                  setHtmlData={handleQuillChange}
                  uplaodImageFile={uploadTextEditorImage}
                />
                <div className="flex w-full justify-end mt-1">
                  <p className={`text-xs mt-0 ${(description?.split(/\s+/)?.filter(Boolean)?.length || 0) > 280 ? 'text-red-500 font-semibold' : 'text-gray-400'}`}>
                    {`${description?.split(/\s+/)?.filter(Boolean)?.length || 0}/280 words`}
                  </p>
                </div>
              </div>
            </DetailsComponent>

            <DetailsComponent
              title={t("lang_search_engine_listing")}
              subtitle={t("lang_search_engine_listing_detail")}
              contentClassName="px-4 sm:px-[25px] pb-4 sm:pb-[25px]"
            >
              <div className="w-full mb-4">
                {meta_tag_title?.length > 0 ? (
                  <div className="w-full bg-white border border-gray-200 rounded-xl shadow-sm hover:shadow-md transition p-4 text-left flex gap-4 items-center justify-between">
                    <div className="flex-1">
                      <p className="text-[#1a0dab] text-[17px] font-medium leading-snug hover:underline cursor-pointer">
                        {meta_tag_title}
                      </p>
                      <div className="flex items-center text-xs text-[#006621] mt-1">
                        {`${protocol}${clientInfo?.custom_domain || clientInfo?.customer_domain}${blogRoute}/${(slugName || '').toLowerCase()}`}
                      </div>
                      <p
                        className="text-[#4d5156] text-sm mt-1 leading-relaxed line-clamp-3"
                        dangerouslySetInnerHTML={{ __html: meta_tag_description }}
                      ></p>
                    </div>
                    {meta_image && (
                      <div className="w-32 h-20 shrink-0 rounded-lg overflow-hidden border border-gray-100 flex items-center justify-center bg-gray-50">
                        <img src={meta_image} className="w-full h-full object-contain" alt="Preview" />
                      </div>
                    )}
                  </div>
                ) : (
                  <div className="w-full bg-gray-50 border rounded-xl shadow-inner p-4 text-left secondary-bg-color main-border-color flex gap-4 items-center justify-between">
                    <div className="flex-1">
                      <p className="text-gray-400 text-[17px] font-medium leading-snug">
                        Example Blog Category Title
                      </p>
                      <div className="flex items-center text-xs text-gray-400 mt-1">
                        yourdomain.com/blog/sample-category
                      </div>
                      <p className="text-gray-400 text-sm mt-1 leading-relaxed">
                        This is a sample meta description. When you add a title and description, your search engine preview will appear here.
                      </p>
                    </div>
                    {meta_image && (
                      <div className="w-32 h-20 shrink-0 rounded-lg overflow-hidden border border-gray-100 flex items-center justify-center bg-gray-50">
                        <img src={meta_image} className="w-full h-full object-contain" alt="Preview" />
                      </div>
                    )}
                  </div>
                )}
              </div>

              <div className="mb-4">
                <AiTextGenerate
                  fieldLabel={t("lang_meta_title")}
                  label={t("lang_get_meta_title")}
                  tooltip={t("lang_meta_tooltip", { type: "title" })}
                  onGenerate={() => generateMetaData(description, "title")}
                />
                <InputComponent
                  type="text"
                  id="Meta Tag Title"
                  name="meta_tag_title"
                  value={meta_tag_title}
                  onChange={HandleInput}
                  placeholder="Enter meta title"
                />
                <div className="flex w-full justify-end mt-1">
                  <p className={`text-xs mt-0 ${(meta_tag_title?.length || 0) > 60 ? 'text-red-500 font-semibold' : 'text-gray-400'}`}>
                    {`${meta_tag_title?.length || 0}/60`}
                  </p>
                </div>
              </div>

              <div className="mb-4">
                <AiTextGenerate
                  fieldLabel={t("lang_meta_description")}
                  label={t("lang_get_meta_description")}
                  tooltip={t("lang_meta_tooltip", { type: "description" })}
                  onGenerate={() => generateMetaData(description, "description")}
                />
                <textarea
                  className="w-full h-24 block px-3 py-2 border border-[var(--border-color)] rounded-lg focus:outline-none focus:border-[var(--focus-border-color)] bg-[var(--secondary-bg-color)] text-[var(--primary-text-color)] text-sm"
                  id="Meta Tag description"
                  name="meta_tag_description"
                  value={(meta_tag_description || '').replace(/<[^>]+>/g, '')}
                  onChange={HandleInput}
                  placeholder="Enter meta description"
                />
                <div className="flex w-full justify-end mt-1">
                  <p className={`text-xs mt-0 ${((meta_tag_description || '').replace(/<[^>]+>/g, '').length || 0) > 160 ? 'text-red-500 font-semibold' : 'text-gray-400'}`}>
                    {`${(meta_tag_description || '').replace(/<[^>]+>/g, '').length || 0}/160 words`}
                  </p>
                </div>
              </div>

              <div className="mb-4">
                <label htmlFor="keyword">{t("lang_meta_keywords")}</label>
                <InputComponent
                  type="text"
                  id="keyword"
                  name="keyword"
                  value={keyword}
                  onChange={HandleInput}
                  placeholder="e.g. Cloth fashion"
                />
              </div>

              <div className="w-full">
                <label htmlFor="meta_image">
                  <p className="text-[13px] mb-1">{t("lang_meta_image") || "Meta Image"}</p>
                </label>
                <ImageUploader
                  tabIndex={16}
                  alreadyImage={meta_image}
                  handleSetImage={(value) => setBlogCatData({ ...BlogCatData, meta_image: value })}
                  folder="og"
                  format="image"
                  removeImages={() => setBlogCatData({ ...BlogCatData, meta_image: "" })}
                />
              </div>
            </DetailsComponent>
          </form>
        </div>
        <div className="flex items-center shadow fixed justify-between w-full bottom-[0px] z-50 secondary-bg-color border-t main-border-color p-4 left-0">
          <div className="w-full lg:w-[70%] xl:w-[60%] mx-auto flex items-center justify-between">
            <Link
              onClick={(e) => {
                e.preventDefault();
                checkChanges();
              }}
              className="w-fit flex text-link font-medium hover:underline text-sm items-center"
            >
              <ArrowLeft className="w-3 mr-1" />
              {t("lang_Go_To_Blog_Categories")}
            </Link>
            <div>
              {blogcategory_name === "" ? (
                <ButtonComponent variant="primary" disabled type="button">
                  {t("lang_Add_New_Blog_Category")}
                </ButtonComponent>
              ) : btnLoading ? (
                <ButtonComponent variant="primary" loading type="button">
                  {t("lang_loading")}...
                </ButtonComponent>
              ) : (
                <ButtonComponent variant="primary" onClick={(e) => HandleSubmit(e)}>
                  {t("lang_Add_New_Blog_Category")}
                </ButtonComponent>
              )}
            </div>
          </div>
        </div>
      </div>
      {html?.htmlPP && (
        <SourceCode
          open={html?.htmlPP}
          htmlCode={html?.code}
          closeCode={closeCode}
          saveHTML={saveHTML}
        />
      )}
    </>
  );
};

export default AddBlogCategory;
